import * as React from 'react';
import * as classNames from 'classnames';
import * as CreDtos from "../../../CRE.dtos";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spinner } from '../../Controls/Spinner';
import * as PeopleActionCreators from "../../../actions/people.actions";

export interface IPeople {
    people: CreDtos.People[];
    categories: CreDtos.Category[];
    isLoading: boolean;
    load: Function;
    edit: Function;
    add: Function;
    search: string;
    category: number;
    showDisabled: boolean;
    showInternal: boolean;
    showExternal: boolean;
    filter: Function;
}

interface IPeopleState {
    search: string
}

class People extends React.Component<IPeople, IPeopleState> {
    constructor(props: IPeople) {
        super(props);
        this.props.load();
        // push to redux state
        this.state = {
            search: this.props.search
        }
        this.onCategoryChanged = this.onCategoryChanged.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onSearchChanged = this.onSearchChanged.bind(this);
        this.onShowDisabledChanged = this.onShowDisabledChanged.bind(this);
        this.onShowInternalChanged = this.onShowInternalChanged.bind(this);
        this.onShowExternalChanged = this.onShowExternalChanged.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.search != this.props.search) {

        }
    }

    onCategoryChanged(id: number) {
        this.props.filter(this.props.search, id, this.props.showDisabled, this.props.showInternal, this.props.showExternal);
    }


    onSearchChanged(e) {
        this.setState({ search: e });
    }

    onSearch() {
        this.props.filter(this.state.search, this.props.category, this.props.showDisabled, this.props.showInternal, this.props.showExternal);
    }

    onShowDisabledChanged(e) {
        this.props.filter(this.props.search, this.props.category, !this.props.showDisabled, this.props.showInternal, this.props.showExternal);
    }

    onShowInternalChanged(e) {
        this.props.filter(this.props.search, this.props.category, this.props.showDisabled, !this.props.showInternal, this.props.showExternal);
    }

    onShowExternalChanged(e) {
        this.props.filter(this.props.search, this.props.category, this.props.showDisabled, this.props.showInternal, !this.props.showExternal);
    }

    render() {
        let content;

        if (this.props.isLoading) {
            content = (
                <Spinner isOpen={this.props.isLoading} />
            );
        } else {
            let items;
            if (this.props.people.length > 0) {
                items = this.props.people.map((item, index) => {
                    let img = item.img;
                    if (!img || img.length == 0) {
                        img = "./images/Unconfirmed.png";
                    }
                    return (
                        <div className="row pt-2 pb-2" key={"people" + item.id}>
                            <div className="col col-3 col-lg-1">
                                <div className="circle-avatar">
                                    <img src={img} />
                                </div>
                            </div>
                            <div className={classNames("col col-12 col-lg-4", { "row-disabled-text": !item.enabled })}>{item.title}</div>
                            <div className={classNames("col col-17 col-lg-5", { "row-disabled-text": !item.enabled })}>{item.peopleCategoriesDisplay}</div>
                            <div className="col col-1 col-lg-1 text-center">
                                {this.props.category != 0 && (
                                    <span>{item.sortOrder}</span>
                                )}
                            </div>
                            <div className="col col-6 col-lg-1">
                                <div className="text-right mr-2" onClick={() => this.props.edit(item)}>
                                    <a><span className="fa fa-edit fa-lg"></span></a>
                                </div>
                            </div>
                        </div>
                    )
                })
            } else {
                items = (
                    <div className="alert alert-info text-center" role="alert">
                        No records found
                    </div>
                );
            }

            let categories = (
                <div className="input-group">
                    <fieldset className="form-group">
                        <div className="form-check">
                            <label className="form-check-label">
                                <input type="radio" className="form-check-input" name="optionsCategories" id="category0" onClick={() => this.onCategoryChanged(0)} checked={this.props.category == 0} />
                                &nbsp;&nbsp;All
                            </label>
                        </div>
                        {this.props.categories.map((item) => (
                            <div className="form-check" key={"category" + item.id}>
                                <label className="form-check-label">
                                    <input type="radio" className="form-check-input" name="optionsCategories" id={"category" + item.id} onClick={() => this.onCategoryChanged(item.id)} checked={this.props.category == item.id} />
                                    &nbsp;&nbsp;{item.categoryName}
                                </label>
                            </div>
                        ))}

                    </fieldset>
                </div>
            );

            let search = (
                <div className="search input-group mb-2">
                    <input type="search" className="form-control lightgrey-bg"
                        placeholder="Search..."
                        defaultValue={this.state.search}
                        onChange={(e) => this.onSearchChanged(e.target.value)}
                        onBlur={() => this.onSearch()}
                    />
                    <button type="button" id="searchBtn" className="input-group-addon btn btn-white" onClick={() => this.onSearch()}>
                        <span className="fa fa-search"></span>
                    </button>
                </div>
            );

            let showDisabled = (
                <div className="search input-group mb-2">
                    <label>
                        <input type="checkbox" checked={this.props.showDisabled} onChange={e => this.onShowDisabledChanged(e)} /> Show disabled
                    </label>
                </div>
            )

            let showInternal = (
                <div className="search input-group mb-2">
                    <label>
                        <input type="checkbox" checked={this.props.showInternal} onChange={e => this.onShowInternalChanged(e)} /> Show internal
                    </label>
                </div>
            )

            let showExternal = (
                <div className="search input-group mb-2">
                    <label>
                        <input type="checkbox" checked={this.props.showExternal} onChange={e => this.onShowExternalChanged(e)} /> Show external
                    </label>
                </div>
            )


            content = (
                <div className="row fixed-scrolling-side">
                    <div className="col-12 col-lg-3 pl-md-0 mb-3 discussion-board sidebar">
                        <div className="sidebar-actions">
                            <div className="row">
                                <div className="col-6">
                                    {search}
                                </div>
                                <div className="col-6">
                                    <button type="button" className="btn btn-default btn-block" onClick={() => this.props.add()}>Add Person</button>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <div className="sidebar-actions-lg">
                            {search}
                            {categories}
                            {showDisabled}
                            <hr />
                            <button type="button" className="btn btn-default btn-block" onClick={() => this.props.add()}>Add Person</button>
                        </div>
                    </div>
                    <div className="col-12 col-lg-9">
                        <div className="discussion-board-resource">
                            <div className="row hide-xs hide-md">
                                <div className="col-1 col-lg-1">
                                    <strong></strong>
                                </div>
                                <div className="col-10 col-lg-4">
                                    <strong>NAME</strong>
                                </div>
                                <div className="col-6 col-lg-5">
                                    <strong>CATEGORIES</strong>
                                </div>
                                <div className="col-1 col-lg-1">
                                    <strong></strong>
                                </div>
                                <div className="col-1 col-lg-1">
                                </div>
                            </div>
                            {items}
                        </div>
                    </div>
                </div>

            );
        }

        return (
            <div>
                {content}
            </div>
        );


        return (
            <div id="SectionContainer">
                <section className="content">
                    <div className="container container-admin">
                        <div className="row">
                            <div className={classNames("col-12", "base1-bg")} >
                                <h1 className={classNames("text-center")}>Admin Area</h1>
                            </div>
                        </div>
                        {content}


                        <div className="row fixed-scrolling-side">
                            <div className="col-12 col-lg-3 pl-md-0 mb-3 discussion-board sidebar">
                                <div className="sidebar-actions">
                                    <div className="row">
                                        <div className="col-6">
                                            <form>
                                                <div className="search input-group mb-2">
                                                    <input type="search" id="search" className="form-control lightgrey-bg" placeholder="Search..." name="search.search" value="" />
                                                    <button type="submit" id="searchBtn" className="input-group-addon btn btn-white">
                                                        <span className="fa fa-search"></span>
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-6">
                                            <button type="button" className="btn btn-default btn-block">Add Person</button>
                                        </div>
                                    </div>
                                    <hr />
                                </div>
                                <div className="sidebar-actions-lg">
                                    <form>
                                        <div className="search input-group mb-2">
                                            <input type="search" id="search" className="form-control lightgrey-bg" placeholder="Search..." name="search.search" value="" />
                                            <button type="submit" id="searchBtn" className="input-group-addon btn btn-white">
                                                <span className="fa fa-search"></span>
                                            </button>
                                        </div>
                                        <div className="input-group">
                                            <fieldset className="form-group">
                                                <div className="form-check">
                                                    <label className="form-check-label">
                                                        <input type="radio" className="form-check-input" name="optionsRadios" id="optionsRadios1" value="option1" checked />
                                                        All
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <label className="form-check-label">
                                                        <input type="radio" className="form-check-input" name="optionsRadios" id="optionsRadios2" value="option2" />
                                                        Students and Trainees
                                                    </label>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </form>
                                    <hr />
                                    <button type="button" className="btn btn-default btn-block">Add Person</button>
                                </div>
                            </div>
                            <div className="col-12 col-lg-9">
                                <div className="discussion-board-resource">
                                    <div className="row hide-xs hide-md">
                                        <div className="col-1 col-lg-1">
                                            <strong></strong>
                                        </div>
                                        <div className="col-10 col-lg-4">
                                            <strong>NAME</strong>
                                        </div>
                                        <div className="col-7 col-lg-6">
                                            <strong>CATEGORIES</strong>
                                        </div>
                                        <div className="col-1 col-lg-1">
                                        </div>
                                    </div>
                                    <div className="row pt-2 pb-2">
                                        <div className="col col-3 col-lg-1">
                                            <div className="circle-avatar">
                                                <img src="/api/attachment/44?0.8310951986933486" />
                                            </div>
                                        </div>
                                        <div className="col col-12 col-lg-4">Sam Smith</div>
                                        <div className="col col-18 col-lg-6">Students and Trainees</div>
                                        <div className="col col-6 col-lg-1">
                                            <div className="text-right mr-2">
                                                <a><span className="fa fa-edit fa-lg"></span></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pt-2 pb-2">
                                        <div className="col col-3 col-lg-1">
                                            <div className="circle-avatar">
                                                <img src="./file/4" />
                                            </div>
                                        </div>
                                        <div className="col col-12 col-lg-4"><strong>admin@newtongreen.com</strong></div>
                                        <div className="col col-16 col-lg-6"><strong>Investigators</strong></div>
                                        <div className="col col-6 col-lg-1">
                                            <div className="text-right mr-2"><a><span className="fa fa-edit fa-lg"></span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="card lightgrey-bg">
                            <div className="card-block">
                                <div className="row">
                                    <div className="col-12 col-md-9 push-md-3">
                                        <div className="row">
                                            <div className="col-12 mb-1 ">
                                                <strong>Person</strong>
                                            </div>
                                            <div className="col-12 mb-1 ">
                                                <div className="mb-0 form-group">
                                                    <input type="text" className="form-control" placeholder="First name..." value="" maxLength={255} />
                                                </div>
                                            </div>
                                            <div className="col-12 mb-1 ">
                                                <div className="mb-0 form-group">
                                                    <input type="text" className="form-control" placeholder="Last name..." value="" maxLength={255} />
                                                </div>
                                            </div>
                                            <div className="col-12 mb-1 ">
                                                <div className="mb-0 form-group">
                                                    <select className="form-control" name="user.type">
                                                        <option value="1">Internal</option>
                                                        <option value="2" selected={true}>External</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12 mb-1 ">
                                                <input type="file" id="user.avatarFile" className="form-control" name="user.avatarFile" />
                                            </div>
                                            <div className="col-12 mb-1 show-sm">
                                                <div className="square-avatar" style={{ width: "125px", height: "125px" }}>
                                                    <img src="./file/4" />
                                                </div>
                                            </div>
                                            <div className="col-12 mb-1 ">
                                                <label>
                                                    <input type="checkbox" value="" checked={true} />
                                                    Enabled
                                                </label>
                                            </div>
                                            <div className="col-12 mb-1 ">
                                                <strong>Categories</strong>
                                            </div>
                                            <div className="col-12 mb-1 ">
                                                <label>
                                                    <input type="checkbox" value="" checked={false} />
                                                    Investigators
                                                </label>
                                            </div>
                                            <div className="col-12 mb-1 ">
                                                <label>
                                                    <input type="checkbox" value="" checked={true} />
                                                    Students and Trainees
                                                </label>
                                            </div>
                                            <div className="col-12">
                                                <div className="card grey-bg">
                                                    <div className="card-block">
                                                        <div className="row">
                                                            <div className="col-12 mb-1 ">
                                                                <div className="mb-0 form-group">
                                                                    <label >Sub title (optional)</label>
                                                                    <input type="text" className="form-control" placeholder="e.g. NSW representative..." value="" maxLength={255} />
                                                                </div>
                                                            </div>
                                                            <div className="col-12 mb-1 ">
                                                                <div className="mb-0 form-group">
                                                                    <textarea id="textarea" className="form-control" placeholder="Summary..." rows={3}></textarea>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 mb-1 ">
                                                                <div className="mb-0 form-group">
                                                                    <label >Link (optional)</label>
                                                                    <input type="text" className="form-control" placeholder="https://www..." value="" maxLength={255} />
                                                                </div>
                                                            </div>
                                                            <div className="col-12 mb-1 ">
                                                                <div className="mb-0 form-group">
                                                                    <label >Sort Order</label>
                                                                    <input type="number" className="form-control" placeholder="0" value="" maxLength={255} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <p></p>
                                            </div>
                                            <div className="col-12">
                                                <div className="pull-right">
                                                    <button type="reset" className="btn btn-primary mr-2">CANCEL</button>
                                                    <button type="submit" className="btn btn-primary">SAVE</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col col-12 col-md-3 pull-md-9 hide-sm">
                                        <div className="square-avatar" style={{ width: "125px", height: "125px" }}>
                                            <img src="./file/4" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );

    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        isLoading: state.people.isLoading,
        people: state.people.filteredPeople,
        categories: state.people.categories,
        search: state.people.search,
        category: state.people.category,
        showDisabled: state.people.showDisabled,
        showInternal: state.people.showInternal,
        showExternal: state.people.showExternal
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            load: PeopleActionCreators.peopleRequest,
            filter: PeopleActionCreators.peopleFilter,
            edit: PeopleActionCreators.peopleEdit,
            add: PeopleActionCreators.peopleAdd
        },
        dispatch
    );
};


const PeopleContainer = connect(mapStateToProps, mapDispatchToProps)(
    People
);

export default PeopleContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/People/People.tsx